export default __webpack_public_path__ + "static/measure-notebook-reference-093e15ddcc6934d31639d387c15a936a.jpg";